// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file protocol-message.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file protocol-message.proto.
 */
export const file_protocol_message: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZwcm90b2NvbC1tZXNzYWdlLnByb3RvIlEKDFNpZ25lZFByZUtleRIWCg5zaWduZWRfcHJlX2tleRgBIAEoDBIPCgd2ZXJzaW9uGAIgASgNEhgKEHByb3RvY29sX3ZlcnNpb24YAyABKA0iugEKBkJ1bmRsZRIQCghpZGVudGl0eRgBIAEoDBIzCg9zaWduZWRfcHJlX2tleXMYAiADKAsyGi5CdW5kbGUuU2lnbmVkUHJlS2V5c0VudHJ5EhEKCXNpZ25hdHVyZRgEIAEoDBIRCgl0aW1lc3RhbXAYBSABKAMaQwoSU2lnbmVkUHJlS2V5c0VudHJ5EgsKA2tleRgBIAEoCRIcCgV2YWx1ZRgCIAEoCzINLlNpZ25lZFByZUtleToCOAEiUAoPQnVuZGxlQ29udGFpbmVyEhcKBmJ1bmRsZRgBIAEoCzIHLkJ1bmRsZRIeChZwcml2YXRlX3NpZ25lZF9wcmVfa2V5GAIgASgMSgQIAxAEIjoKCERSSGVhZGVyEgsKA2tleRgBIAEoDBIJCgFuGAIgASgNEgoKAnBuGAMgASgNEgoKAmlkGAQgASgMIhcKCERISGVhZGVyEgsKA2tleRgBIAEoDCIrCgpYM0RISGVhZGVyEgsKA2tleRgBIAEoDBIKCgJpZBgEIAEoDEoECAMQBCJuCghIUkhlYWRlchIZChFkZXByZWNhdGVkX2tleV9pZBgBIAEoDRIOCgZzZXFfbm8YAiABKA0SEAoIZ3JvdXBfaWQYAyABKAwSDgoGa2V5X2lkGAQgASgMEhUKBGtleXMYBSABKAsyBy5IUktleXMicQoKUmVrZXlHcm91cBIRCgl0aW1lc3RhbXAYAiABKAQSIwoEa2V5cxgEIAMoCzIVLlJla2V5R3JvdXAuS2V5c0VudHJ5GisKCUtleXNFbnRyeRILCgNrZXkYASABKA0SDQoFdmFsdWUYAiABKAw6AjgBIkAKBkhSS2V5cxIUCgRrZXlzGAEgAygLMgYuSFJLZXkSIAoLcmVrZXlfZ3JvdXAYAiABKAsyCy5SZWtleUdyb3VwIkIKBUhSS2V5EhkKEWRlcHJlY2F0ZWRfa2V5X2lkGAEgASgNEgsKA2tleRgCIAEoDBIRCgl0aW1lc3RhbXAYAyABKAQipwEKGEVuY3J5cHRlZE1lc3NhZ2VQcm90b2NvbBIgCgtYM0RIX2hlYWRlchgBIAEoCzILLlgzREhIZWFkZXISHAoJRFJfaGVhZGVyGAIgASgLMgkuRFJIZWFkZXISHAoJREhfaGVhZGVyGGUgASgLMgkuREhIZWFkZXISHAoJSFJfaGVhZGVyGGYgASgLMgkuSFJIZWFkZXISDwoHcGF5bG9hZBgDIAEoDCLzAQoPUHJvdG9jb2xNZXNzYWdlEhcKD2luc3RhbGxhdGlvbl9pZBgCIAEoCRIYCgdidW5kbGVzGAMgAygLMgcuQnVuZGxlEkEKEWVuY3J5cHRlZF9tZXNzYWdlGGUgAygLMiYuUHJvdG9jb2xNZXNzYWdlLkVuY3J5cHRlZE1lc3NhZ2VFbnRyeRIWCg5wdWJsaWNfbWVzc2FnZRhmIAEoDBpSChVFbmNyeXB0ZWRNZXNzYWdlRW50cnkSCwoDa2V5GAEgASgJEigKBXZhbHVlGAIgASgLMhkuRW5jcnlwdGVkTWVzc2FnZVByb3RvY29sOgI4AWIGcHJvdG8z',
  )

/**
 * @generated from message SignedPreKey
 */
export type SignedPreKey = Message<'SignedPreKey'> & {
  /**
   * @generated from field: bytes signed_pre_key = 1;
   */
  signedPreKey: Uint8Array

  /**
   * @generated from field: uint32 version = 2;
   */
  version: number

  /**
   * @generated from field: uint32 protocol_version = 3;
   */
  protocolVersion: number
}

/**
 * Describes the message SignedPreKey.
 * Use `create(SignedPreKeySchema)` to create a new message.
 */
export const SignedPreKeySchema: GenMessage<SignedPreKey> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 0)

/**
 * X3DH prekey bundle
 *
 * @generated from message Bundle
 */
export type Bundle = Message<'Bundle'> & {
  /**
   * Identity key
   *
   * @generated from field: bytes identity = 1;
   */
  identity: Uint8Array

  /**
   * Installation id
   *
   * @generated from field: map<string, SignedPreKey> signed_pre_keys = 2;
   */
  signedPreKeys: { [key: string]: SignedPreKey }

  /**
   * Prekey signature
   *
   * @generated from field: bytes signature = 4;
   */
  signature: Uint8Array

  /**
   * When the bundle was created locally
   *
   * @generated from field: int64 timestamp = 5;
   */
  timestamp: bigint
}

/**
 * Describes the message Bundle.
 * Use `create(BundleSchema)` to create a new message.
 */
export const BundleSchema: GenMessage<Bundle> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 1)

/**
 * @generated from message BundleContainer
 */
export type BundleContainer = Message<'BundleContainer'> & {
  /**
   * X3DH prekey bundle
   *
   * @generated from field: Bundle bundle = 1;
   */
  bundle?: Bundle

  /**
   * Private signed prekey
   *
   * @generated from field: bytes private_signed_pre_key = 2;
   */
  privateSignedPreKey: Uint8Array
}

/**
 * Describes the message BundleContainer.
 * Use `create(BundleContainerSchema)` to create a new message.
 */
export const BundleContainerSchema: GenMessage<BundleContainer> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 2)

/**
 * @generated from message DRHeader
 */
export type DRHeader = Message<'DRHeader'> & {
  /**
   * Current ratchet public key
   *
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array

  /**
   * Number of the message in the sending chain
   *
   * @generated from field: uint32 n = 2;
   */
  n: number

  /**
   * Length of the previous sending chain
   *
   * @generated from field: uint32 pn = 3;
   */
  pn: number

  /**
   * Bundle ID
   *
   * @generated from field: bytes id = 4;
   */
  id: Uint8Array
}

/**
 * Describes the message DRHeader.
 * Use `create(DRHeaderSchema)` to create a new message.
 */
export const DRHeaderSchema: GenMessage<DRHeader> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 3)

/**
 * @generated from message DHHeader
 */
export type DHHeader = Message<'DHHeader'> & {
  /**
   * Compressed ephemeral public key
   *
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array
}

/**
 * Describes the message DHHeader.
 * Use `create(DHHeaderSchema)` to create a new message.
 */
export const DHHeaderSchema: GenMessage<DHHeader> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 4)

/**
 * @generated from message X3DHHeader
 */
export type X3DHHeader = Message<'X3DHHeader'> & {
  /**
   * Ephemeral key used
   *
   * @generated from field: bytes key = 1;
   */
  key: Uint8Array

  /**
   * Used bundle's signed prekey
   *
   * @generated from field: bytes id = 4;
   */
  id: Uint8Array
}

/**
 * Describes the message X3DHHeader.
 * Use `create(X3DHHeaderSchema)` to create a new message.
 */
export const X3DHHeaderSchema: GenMessage<X3DHHeader> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 5)

/**
 * Hash Ratchet Header
 *
 * @generated from message HRHeader
 */
export type HRHeader = Message<'HRHeader'> & {
  /**
   * deprecated group key ID
   *
   * @generated from field: uint32 deprecated_key_id = 1;
   */
  deprecatedKeyId: number

  /**
   * group message number for this key_id
   *
   * @generated from field: uint32 seq_no = 2;
   */
  seqNo: number

  /**
   * group ID
   *
   * @generated from field: bytes group_id = 3;
   */
  groupId: Uint8Array

  /**
   * group key ID
   *
   * @generated from field: bytes key_id = 4;
   */
  keyId: Uint8Array

  /**
   * @generated from field: HRKeys keys = 5;
   */
  keys?: HRKeys
}

/**
 * Describes the message HRHeader.
 * Use `create(HRHeaderSchema)` to create a new message.
 */
export const HRHeaderSchema: GenMessage<HRHeader> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 6)

/**
 * @generated from message RekeyGroup
 */
export type RekeyGroup = Message<'RekeyGroup'> & {
  /**
   * @generated from field: uint64 timestamp = 2;
   */
  timestamp: bigint

  /**
   * @generated from field: map<uint32, bytes> keys = 4;
   */
  keys: { [key: number]: Uint8Array }
}

/**
 * Describes the message RekeyGroup.
 * Use `create(RekeyGroupSchema)` to create a new message.
 */
export const RekeyGroupSchema: GenMessage<RekeyGroup> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 7)

/**
 * @generated from message HRKeys
 */
export type HRKeys = Message<'HRKeys'> & {
  /**
   * @generated from field: repeated HRKey keys = 1;
   */
  keys: HRKey[]

  /**
   * @generated from field: RekeyGroup rekey_group = 2;
   */
  rekeyGroup?: RekeyGroup
}

/**
 * Describes the message HRKeys.
 * Use `create(HRKeysSchema)` to create a new message.
 */
export const HRKeysSchema: GenMessage<HRKeys> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 8)

/**
 * @generated from message HRKey
 */
export type HRKey = Message<'HRKey'> & {
  /**
   * @generated from field: uint32 deprecated_key_id = 1;
   */
  deprecatedKeyId: number

  /**
   * @generated from field: bytes key = 2;
   */
  key: Uint8Array

  /**
   * @generated from field: uint64 timestamp = 3;
   */
  timestamp: bigint
}

/**
 * Describes the message HRKey.
 * Use `create(HRKeySchema)` to create a new message.
 */
export const HRKeySchema: GenMessage<HRKey> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 9)

/**
 * Direct message value
 *
 * @generated from message EncryptedMessageProtocol
 */
export type EncryptedMessageProtocol = Message<'EncryptedMessageProtocol'> & {
  /**
   * @generated from field: X3DHHeader X3DH_header = 1;
   */
  X3DHHeader?: X3DHHeader

  /**
   * @generated from field: DRHeader DR_header = 2;
   */
  DRHeader?: DRHeader

  /**
   * @generated from field: DHHeader DH_header = 101;
   */
  DHHeader?: DHHeader

  /**
   * @generated from field: HRHeader HR_header = 102;
   */
  HRHeader?: HRHeader

  /**
   * Encrypted payload
   *
   * @generated from field: bytes payload = 3;
   */
  payload: Uint8Array
}

/**
 * Describes the message EncryptedMessageProtocol.
 * Use `create(EncryptedMessageProtocolSchema)` to create a new message.
 */
export const EncryptedMessageProtocolSchema: GenMessage<EncryptedMessageProtocol> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 10)

/**
 * Top-level protocol message
 *
 * @generated from message ProtocolMessage
 */
export type ProtocolMessage = Message<'ProtocolMessage'> & {
  /**
   * The device id of the sender
   *
   * @generated from field: string installation_id = 2;
   */
  installationId: string

  /**
   * List of bundles
   *
   * @generated from field: repeated Bundle bundles = 3;
   */
  bundles: Bundle[]

  /**
   * One to one message, encrypted, indexed by installation_id
   * TODO map here is redundant in case of community messages
   *
   * @generated from field: map<string, EncryptedMessageProtocol> encrypted_message = 101;
   */
  encryptedMessage: { [key: string]: EncryptedMessageProtocol }

  /**
   * Public chats, not encrypted
   *
   * @generated from field: bytes public_message = 102;
   */
  publicMessage: Uint8Array
}

/**
 * Describes the message ProtocolMessage.
 * Use `create(ProtocolMessageSchema)` to create a new message.
 */
export const ProtocolMessageSchema: GenMessage<ProtocolMessage> =
  /*@__PURE__*/
  messageDesc(file_protocol_message, 11)
